import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTickets, openTicketModal } from '../../../store/fuse/nivelService';
import { WrapperTotal } from './styles';
import RangeTicketChart from './RangeTicketChart';

const { VictoryPie, VictoryLabel } = require('victory');

const TotalByTotal = (props) => {
  const dispatch = useDispatch();
  const open = useSelector((state) => state?.fuse?.nivelService?.ticketModal?.open);
  const ticketsColorData = useSelector((state) => state.fuse?.nivelService.totalTickets);

  const handleOpenModal = (data) => {
    if (data.x === 'Abiertos') {
      dispatch(getTickets(data.start, data.end, 2));
    }
    if (data.x === 'En Curso') {
      dispatch(getTickets(data.start, data.end, 3));
    }
    if (data.x === 'Resueltos') {
      dispatch(getTickets(data.start, data.end, 1));
    }
    dispatch(openTicketModal(open));
  };

  const displayPercentageLabel = (data, rowData) => {
    if ('x' in rowData && 'nameTotal' in data) {
      const total = data.dataTotal.reduce((accumulator, currentValue) => accumulator + currentValue.y, 0);
      if (total === 0) return '0%';
      return `${Math.round((rowData.y / total) * 100 * 100) / 100}%`;
    }
    return '';
  };

  return (
    <WrapperTotal>
      <div className="section-by-total">
        <div className="section-title">
          <h3>Total de Tickets x tiempo de vida y status</h3>
        </div>
        <div className="section-chart">
          {Object.keys(props?.bytotal[0]).length === 0 ? (
            <h1>Sin Resultados</h1>
          ) : (
            props?.bytotal?.map((ticketsData, index) => (
              <div key={index} className="w-1/4 m-10 p-10">
                <RangeTicketChart ticketsData={ticketsData} handleOpenModal={handleOpenModal} />
              </div>
            ))
          )}
        </div>
      </div>
    </WrapperTotal>
  );
};

export default TotalByTotal;
